export default __webpack_public_path__ + "static/media/MINUSMA_head_visits_timbuktu.9a4623a3.jpg";